import axios from 'axios';
import iziToast from "izitoast";
import { internalServerError } from "../utils/consts/pathRoutes";
import { landingRoute } from '../utils/consts/roles';
import { getToken, setToken } from "../utils/token";

export const Registration = async (name, role, email, password) => {
  try {
    const response = await axios.post(`${process.env.REACT_APP_URL_PATH}/api/auth/register`, {
      name: name,
      email: email,
      password: password,
      role: role
    }, {
      headers: {
        'Authorization': getToken(),
        'Content-Type': 'application/json'
      }
    });
    iziToast.success({
      message: response.data.message,
      position: "topRight"
    });
  } catch (e) {
    iziToast.error({
      message: internalServerError(e),
      position: "topRight",
      color: "#FFF2ED"
    });
  }
};

export const Login = async (email, password, navigate) => {
  try {
    const response = await axios.post(`${process.env.REACT_APP_URL_PATH}/api/auth/login`, {
      email,
      password
    });
    setToken(response.data.token);
    iziToast.success({
      message: response.data.message,
      position: "topRight"
    });
    navigate(landingRoute());
  } catch (e) {
    iziToast.error({
      message: internalServerError(e),
      position: "topRight",
      color: "#FFF2ED"
    });
  }
};

export function getUsers() {
  return axios.get(`${process.env.REACT_APP_URL_PATH}/api/user/`, {
    headers: {
      Authorization: getToken()
    }
  }).then(resp => resp.data);
}

export function changeUserData(data, id) {
  return axios.put(`${process.env.REACT_APP_URL_PATH}/api/user/change/${id}`, data, {
    headers: {
      'Authorization': getToken(),
      'Content-Type': 'application/json;charset=utf-8'
    }
  })
    .then(({ data }) => {
      iziToast.success({
        message: data.message,
        position: 'topRight'
      });
      setTimeout(() => {
        window.location.reload();
      }, 1500);
    }).catch((e) => {
      iziToast.error({
        message: internalServerError(e),
        position: "topRight",
        color: "#FFF2ED"
      });
    });
}

export function changeYourself(data) {
  return axios.put(`${process.env.REACT_APP_URL_PATH}/api/user/change`, data, {
    headers: {
      'Authorization': getToken(),
      'Content-Type': 'application/json;charset=utf-8'
    }
  })
    .then(({ data }) => {
      if (data.token !== undefined)
        setToken(data.token);
      iziToast.success({
        message: data.message,
        position: 'topRight'
      });
      setTimeout(() => {
        window.location.reload();
      }, 1500);
    }).catch((e) => {
      iziToast.error({
        message: internalServerError(e),
        position: "topRight",
        color: "#FFF2ED"
      });
    });
}

export function removeUserById(id) {
  return axios.delete(`${process.env.REACT_APP_URL_PATH}/api/user/remove/${id}`, {
    headers: {
      'Authorization': getToken(),
      'Content-Type': 'application/json;charset=utf-8'
    }
  }).then(({ data }) => {
    iziToast.success({
      message: data.message,
      position: 'topRight'
    });
    setTimeout(() => {
      window.location.reload();
    }, 1500);
  }).catch((e) => {
    iziToast.error({
      message: internalServerError(e),
      position: "topRight",
      color: "#FFF2ED"
    });
  });

}

// ─── Управление пользователями в личном кабинете ──────────────────────────────
// Функции выше перезагружают страницу после успеха. Таблице это не подходит:
// она обновляется на месте, поэтому здесь чистые запросы без побочных эффектов.

const usersApi = (method, url, data) => axios({
  method,
  url: `${process.env.REACT_APP_URL_PATH}/api/${url}`,
  data,
  headers: { Authorization: getToken(), 'Content-Type': 'application/json;charset=utf-8' },
}).then((resp) => resp.data);

export const fetchUsers = () => usersApi('get', 'user/');

export const createUser = (payload) => usersApi('post', 'auth/register', payload);

export const updateUser = (id, payload) => usersApi('put', `user/change/${id}`, payload);

export const deactivateUser = (id) => usersApi('delete', `user/remove/${id}`);

export const activateUser = (id) => usersApi('put', `user/activate/${id}`);

/** Имя и логин своего профиля. Сервер возвращает новый токен — в нём имя и email. */
export const updateOwnProfile = (payload) => usersApi('put', 'user/change', payload)
  .then((data) => {
    if (data.token) setToken(data.token);
    return data;
  });
